/* RESPONSIBLE TEAM: team-help-desk-experience */
import Route from '@ember/routing/route';

export default class WelcomeHelpdeskRoute extends Route {}
